import { fromJS } from 'immutable'
import * as criticalComponetsActions from './criticalComponentsActions'

let initialState = fromJS({
	isLoading: false,
	isSaving: false,
	criticalComponentsDashboard: null,
	filterOptions: null
})

/**
 * criticalComponetsReducer reducer
 */
const criticalComponentsReducer = (state = initialState, action) => {
	switch (action.type) {
		case criticalComponetsActions.IS_LOADING:
			return state.merge({
				isLoading: action.status
			})
		case criticalComponetsActions.SET_ALL_DATA: {
			return state.merge({
				criticalComponentsDashboard: fromJS(action.data),
				isLoading: false
			})
		}
		case criticalComponetsActions.SET_FILTER_OPTIONS:
			return state.merge({
				filterOptions: fromJS(action.data)
			})
		case criticalComponetsActions.SET_DYNAMIC_FILTER_OPTIONS:
			return state.set(
				`${action.field}Options`,
				fromJS(action.data)
			)
		default:
			return state
	}
}

export default criticalComponentsReducer
